import { Cell } from '@zeiss/beyond-online-react';
import { Box, Grid } from '@zeiss/lib-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { StyledPreviewCard } from 'src/components/shared/StyledPreviewCard';
import { ApplicationListResponse } from 'src/types/rest/tenant';

interface ResultItemsProps {
  items: ApplicationListResponse[];
}
export const ResultItems = ({ items }: ResultItemsProps) => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  return (
    <Box>
      <Grid>
        {items.map(({ createdTimestamp, id, name }) => {
          const formattedDate = new Date(createdTimestamp).toLocaleDateString();

          return (
            <Cell.Basic colSpan={[4, 6, 5, 4]} key={id}>
              <StyledPreviewCard
                chips={null}
                desktopVariant="grid-item"
                headline={name}
                link={() => navigate(id)}
                properties={[
                  {
                    key: t('common:creationDate'),
                    value: formattedDate,
                  },
                ]}
              />
            </Cell.Basic>
          );
        })}
      </Grid>
    </Box>
  );
};
